// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"55943946","664":"06247281","692":"45ff1c66","777":"458971ab","787":"1dedba98","932":"61fe4d46","975":"64a04ae1"}[chunkId] + ".chunk.js";
};